import { LayoutType, withLayout } from 'src/hocs/withLayout'

import { Home } from './Home'

const WrappedHome = withLayout(LayoutType.Default, Home)

export { WrappedHome as Home }
